// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bundleBadge":"_3j2xu","grid":"_2-OgW","list":"_1Je1-","btmLft":"wo0mh","topLft":"_1aNNm","text":"_1MfXm","circle":"SRd4j"};